import { render, staticRenderFns } from "./FileWithPreview.vue?vue&type=template&id=d65f57c6&scoped=true"
import script from "./FileWithPreview.vue?vue&type=script&lang=js"
export * from "./FileWithPreview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d65f57c6",
  null
  
)

export default component.exports